import { Modal, Heading, Text, Input, Button } from 'mondrian-react';
import styles from './styles.module.css';
import { useState } from 'react';
import { useLoader } from '../../../../../hooks/loader';
import { Auth } from 'aws-amplify';

function ModalMdn(props) {
  const { open, close } = props;
  const { setLoading } = useLoader('');
  const [step, setStep] = useState(1);
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');

  const [inputPasswordError, setInputPasswordError] = useState(false);
  const [inputPasswordErrorMessage, setInputPasswordErrorMessage] = useState(
    '',
  );
  const [inputError, setInputError] = useState(false);
  const [inputErrorMessage, setInputErrorMessage] = useState('');

  const handleClose = () => {
    setStep(1);
    setPassword('');
    setNewPassword('');
    setConfirmNewPassword('');
    setInputPasswordError(false);
    setInputPasswordErrorMessage('');
    setInputError(false);
    setInputErrorMessage('');
    close();
  };

  async function lazyState() {
    return;
  }

  const handleChangePasswordSubmit = async (event) => {
    event.preventDefault();

    await lazyState();
    setLoading(true);
    setInputPasswordError(false);
    setInputPasswordErrorMessage('');
    setInputError(false);
    setInputErrorMessage('');

    if (newPassword !== confirmNewPassword) {
      setInputErrorMessage('As senhas precisam ser iguais.');
      setLoading(false);
      setInputError(true);

      setNewPassword(newPassword);
      setConfirmNewPassword(confirmNewPassword);

      return;
    } else {
      Auth.currentAuthenticatedUser()
        .then((user) => {
          Auth.changePassword(user, password, newPassword)
            .then(() => {
              setLoading(false);
              return setStep(2);
            })
            .catch((err) => {
              console.log(err);

              if (err.code === 'NotAuthorizedException') {
                setInputPasswordErrorMessage('Senha incorreta.');
                setInputPasswordError(true);
                setLoading(false);
              }

              if (
                err.code === 'InvalidParameterException' ||
                err.code === 'InvalidPasswordException'
              ) {
                setInputErrorMessage(
                  'Mínimo 8 caracteres. Minúscula, maiúscula e especial.',
                );
                setInputError(true);
                setLoading(false);
              }

              if (err.code === 'LimitExceededException') {
                setInputErrorMessage(
                  'Limite de tentativas excedido, tente novamente mais tarde.',
                );
                setInputPasswordErrorMessage(
                  'Limite de tentativas excedido, tente novamente mais tarde.',
                );
                setInputError(true);
                setInputPasswordError(true);
                setLoading(false);
              }
            });
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  };

  return (
    <div>
      <Modal
        id="Modal-ChangePassword"
        data={{
          header: <Heading md>Resetar senha</Heading>,
          content: (
            <>
              {step === 1 && (
                <div>
                  <Text body className={styles.FormHeader}>
                    Preencha os campos abaixo.
                  </Text>
                  <form
                    autoComplete="new-password"
                    onSubmit={handleChangePasswordSubmit}
                    noValidate
                  >
                    <div className={styles.FormInput}>
                      <Input
                        required
                        password
                        name="password"
                        id="password"
                        autoComplete="password"
                        onChange={(e) => setPassword(e.target.value)}
                        hasError={!inputPasswordError ? false : true}
                        errorMessage={
                          !inputPasswordErrorMessage
                            ? ''
                            : inputPasswordErrorMessage
                        }
                        parentClassName={
                          inputPasswordError && 'mdn-Input--attentionField'
                        }
                        value={password}
                      >
                        Senha atual
                      </Input>
                    </div>
                    <div className={styles.FormInput}>
                      <Input
                        required
                        password
                        name="new-password"
                        id="new-password"
                        autoComplete="new-password"
                        onChange={(e) => setNewPassword(e.target.value)}
                        hasError={inputError}
                        errorMessage={inputErrorMessage}
                        parentClassName={
                          inputError && 'mdn-Input--attentionField'
                        }
                        value={newPassword}
                      >
                        Nova senha
                      </Input>
                    </div>
                    <div className={styles.FormInput}>
                      <Input
                        required
                        password
                        name="confirm-password"
                        id="confirm-password"
                        autoComplete="new-password"
                        onChange={(e) => setConfirmNewPassword(e.target.value)}
                        hasError={inputError}
                        errorMessage={inputErrorMessage}
                        parentClassName={
                          inputError && 'mdn-Input--attentionField'
                        }
                        value={confirmNewPassword}
                      >
                        Confirme a nova senha
                      </Input>
                    </div>

                    <Button
                      block
                      submit="true"
                      className={styles.FormButton}
                      disabled={
                        password && newPassword && confirmNewPassword
                          ? false
                          : true
                      }
                    >
                      Enviar
                    </Button>
                  </form>
                </div>
              )}

              {step === 2 && (
                <div className={styles.Step2}>
                  <div className="mdn-Topic mdn-Topic--vertical mdn-Topic--icon">
                    <div className="mdn-Topic-symbol">
                      <i className="mdn-Icon-verificado mdn-Icon--md"></i>
                    </div>
                    <p className="mdn-Topic-description">
                      Sua senha foi <br /> alterada com sucesso!
                    </p>
                  </div>
                </div>
              )}
            </>
          ),
          isOpen: open,
          onCloseClick: handleClose,
        }}
      />
    </div>
  );
}

export default ModalMdn;
